<template>
  <button
    :id="id"
    type="button"
    class="btn"
    :class="[color, { color, invert, full, 'no-padding': noPadding, 'rounded-full': roundedFull }]"
    :="$attrs"
  >
    <slot>{{ text }}</slot>
  </button>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    id?: string
    text?: string
    color?: string
    invert?: boolean
    full?: boolean
    noPadding?: boolean
    roundedFull?: boolean
  }>(),
  {
    roundedFull: true,
  },
)
</script>

<style lang="scss" scoped>
$padding-right: 20px;
$padding-default: 12px $padding-right;

.full {
  width: 100%;
}

.white {
  --text-color: #{$grey-300};
  --background-color: #{$white};
}

.red {
  --text-color: #{$white};
  --background-color: #{$brand-secondary};
}

.blue {
  --text-color: #{$white};
  --background-color: #{$brand-primary};
}

.green {
  --text-color: #{$white};
  --background-color: #{$brand-tertiary};
}

.btn {
  @include base-font;
  font-weight: 500;
  padding: $padding-default;
  border-radius: $rounded-2xl;

  &.rounded-full {
    border-radius: 1000px;
  }

  color: $blue-500;
  background: $white;
  border: 1px solid $green-50;

  &.color {
    color: var(--text-color);
    background-color: var(--background-color);
    border: 1px solid var(--background-color);
  }

  &.color.invert {
    color: var(--background-color);
    background-color: var(--text-color);
  }

  &:disabled {
    pointer-events: none;
    filter: grayscale(1) opacity(0.5);
  }

  &.no-padding {
    padding: 0;
  }

  :deep(a) {
    padding: $padding-default;
    display: block;
    color: inherit;
  }
}
</style>
